import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import './api'
import router from './router/index'
import store from './plugins/store.js'
import authManager from './util/auth'
// Vue.config.productionTip = false
Vue.config.devtools = true

// Add this before creating the Vue instance
window.__vueInstance = null;

// 创建Vue实例
const app = new Vue({
  render: h => h(App),
  router: router,
  store,
  async created() {
    window.__vueInstance = this;
    
    // 初始化认证状态
    try {
      console.log('Initializing authentication...')
      const isAuthenticated = await authManager.initializeAuth()
      console.log('Authentication initialized:', isAuthenticated)
      
      // 将认证管理器添加到Vue实例中，方便组件使用
      this.$auth = authManager
    } catch (error) {
      console.error('Failed to initialize authentication:', error)
    }
  }
})

// 将认证管理器添加到Vue原型中
Vue.prototype.$auth = authManager

app.$mount('#app')
